<template>
  <div class="page well-page">
    <h2 class="page-title">泉井管理</h2>
    <div class="filter-card">
      <el-form :model="query" size="small" label-width="68px" class="filter-form">
        <el-row :gutter="12">
          <el-col :xl="5" :lg="6" :md="8" :sm="12" :xs="24">
            <el-form-item label="泉井名称"><el-input v-model="query.name" placeholder="输入泉井名称" clearable /></el-form-item>
          </el-col>
          <el-col :xl="4" :lg="6" :md="8" :sm="12" :xs="24">
            <el-form-item label="审核状态">
              <el-select v-model="query.reviewStatus" clearable placeholder="全部">
                <el-option label="待审核" :value="0" />
                <el-option label="审核中" :value="1" />
                <el-option label="已通过" :value="2" />
                <el-option label="未通过" :value="3" />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :xl="3" :lg="4" :md="8" :sm="12" :xs="24">
            <el-form-item label="类型">
              <el-select v-model="query.wellType" clearable placeholder="全部">
                <el-option label="泉" :value="1" />
                <el-option label="井" :value="2" />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :xl="4" :lg="6" :md="8" :sm="12" :xs="24">
            <el-form-item label="省份"><el-input v-model="query.province" placeholder="请输入省份" clearable /></el-form-item>
          </el-col>
          <el-col :xl="4" :lg="6" :md="8" :sm="12" :xs="24">
            <el-form-item label="城市"><el-input v-model="query.city" placeholder="请输入城市" clearable /></el-form-item>
          </el-col>
          <el-col :xl="4" :lg="6" :md="8" :sm="12" :xs="24">
            <el-form-item label="区县"><el-input v-model="query.district" placeholder="请输入区县" clearable /></el-form-item>
          </el-col>
          <el-col :xl="4" :lg="6" :md="8" :sm="12" :xs="24">
            <el-form-item label="上报人"><el-input v-model="query.reporterKeyword" placeholder="姓名/电话" clearable /></el-form-item>
          </el-col>
          <el-col :xl="8" :lg="10" :md="12" :sm="24" :xs="24">
            <el-form-item label="创建时间">
              <el-date-picker v-model="dateRange" type="daterange" value-format="yyyy-MM-dd" range-separator="-" start-placeholder="开始日期" end-placeholder="结束日期" clearable />
            </el-form-item>
          </el-col>
          <el-col :xl="4" :lg="8" :md="12" :sm="24" :xs="24">
            <el-form-item class="filter-actions">
              <el-button type="primary" @click="handleSearch">查询</el-button>
              <el-button @click="handleReset">重置</el-button>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </div>

    <div class="table-card">
      <div class="table-toolbar">
        <el-button type="primary" size="small" @click="openCreate">新增</el-button>
        <el-button size="small" @click="exportList">导出</el-button>
      </div>
      <el-table :data="tableData" v-loading="loading" border>
        <el-table-column prop="id" label="ID" width="70" />
        <el-table-column label="封面" width="90"><template slot-scope="scope"><el-image class="cover" :src="resolveImageUrl(scope.row.coverImg)" fit="cover" /></template></el-table-column>
        <el-table-column prop="name" label="泉井名称" min-width="150" />
        <el-table-column label="类型" width="80"><template slot-scope="scope"><el-tag>{{ scope.row.wellTypeText || wellTypeText(scope.row.wellType) }}</el-tag></template></el-table-column>
        <el-table-column label="水位" width="90"><template slot-scope="scope"><el-tag type="success">{{ scope.row.waterLevelLabel }}</el-tag></template></el-table-column>
        <el-table-column prop="useFrequencyText" label="使用频率" width="120" />
        <el-table-column prop="province" label="省" width="90" />
        <el-table-column prop="city" label="市" width="90" />
        <el-table-column prop="district" label="区县" width="100" />
        <el-table-column prop="address" label="详细地址" min-width="220" show-overflow-tooltip />
        <el-table-column label="经纬度" width="190"><template slot-scope="scope">{{ scope.row.longitude }}, {{ scope.row.latitude }}</template></el-table-column>
        <el-table-column prop="reporterName" label="上报人" width="110" />
        <el-table-column prop="contact" label="联系方式" width="140" />
        <el-table-column label="上报时间" width="170"><template slot-scope="scope">{{ formatDateTime(scope.row.createdAt) }}</template></el-table-column>
        <el-table-column label="审核状态" width="110"><template slot-scope="scope"><el-tag :type="reviewType(scope.row.reviewStatus)">{{ reviewText(scope.row.reviewStatus) }}</el-tag></template></el-table-column>
        <el-table-column label="显示状态" width="100"><template slot-scope="scope"><el-tag :type="displayType(scope.row.shelfStatus)">{{ displayText(scope.row.shelfStatus) }}</el-tag></template></el-table-column>
        <el-table-column label="操作" width="150" fixed="right">
          <template slot-scope="scope">
            <div class="action-bar">
              <span class="action-text view" @click="openView(scope.row)">查看</span>
              <span class="action-text edit" @click="openEdit(scope.row)">修改</span>
              <span v-if="scope.row.reviewStatus !== 2" class="action-text audit" @click="openAudit(scope.row)">审核</span>

              <span class="action-text delete" @click="handleDelete(scope.row)">删除</span>
            </div>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination background layout="prev, pager, next, total" :total="total" :current-page.sync="query.pageNum" :page-size="query.pageSize" @current-change="loadData" />
    </div>

    <el-dialog :title="dialogTitle" :visible.sync="dialogVisible" width="920px">
      <el-form v-if="dialogMode === 'edit' || dialogMode === 'create'" ref="editForm" :model="editForm" :rules="editRules" label-width="90px" class="edit-form">
        <el-row :gutter="12">
          <el-col :span="12"><el-form-item label="泉井名称" prop="name"><el-input v-model="editForm.name" /></el-form-item></el-col>
          <el-col :span="12"><el-form-item label="类型" prop="wellType"><el-select v-model="editForm.wellType"><el-option label="泉" :value="1" /><el-option label="井" :value="2" /></el-select></el-form-item></el-col>

          <el-col :span="12"><el-form-item label="经度" prop="longitude"><el-input v-model="editForm.longitude" /></el-form-item></el-col>
          <el-col :span="12"><el-form-item label="纬度" prop="latitude"><el-input v-model="editForm.latitude" /></el-form-item></el-col>
          <el-col :span="8"><el-form-item label="省份"><el-input v-model="editForm.province" /></el-form-item></el-col>
          <el-col :span="8"><el-form-item label="城市"><el-input v-model="editForm.city" /></el-form-item></el-col>
          <el-col :span="8"><el-form-item label="区县"><el-input v-model="editForm.district" /></el-form-item></el-col>
          <el-col :span="12"><el-form-item label="水位" prop="waterLevel"><el-select v-model="editForm.waterLevel" style="width:100%"><el-option-group label="泉"><el-option label="丰水泉" :value="1" /><el-option label="平水泉" :value="2" /><el-option label="枯水泉" :value="3" /><el-option label="间歇泉" :value="4" /></el-option-group><el-option-group label="井"><el-option label="满井" :value="11" /><el-option label="常规井" :value="12" /><el-option label="浅枯井" :value="13" /><el-option label="干润井" :value="14" /></el-option-group></el-select></el-form-item></el-col>
          <el-col :span="12"><el-form-item label="使用频率" prop="useFrequency"><el-select v-model="editForm.useFrequency" style="width:100%"><el-option label="高频公用" :value="1" /><el-option label="中频常用" :value="2" /><el-option label="低频小众" :value="3" /><el-option label="闲置少用" :value="4" /></el-select></el-form-item></el-col>
          <el-col :span="12"><el-form-item label="上报人"><el-input v-model="editForm.reporterName" /></el-form-item></el-col>
          <el-col :span="12"><el-form-item label="联系方式"><el-input v-model="editForm.contact" /></el-form-item></el-col>
          <el-col :span="12"><el-form-item label="水质状态"><el-select v-model="editForm.manualTestStatus" clearable placeholder="自动计算" style="width:100%"><el-option label="可用" value="可用" /><el-option label="待检测" value="待检测" /><el-option label="有风险" value="有风险" /></el-select><div style="font-size:12px;color:#999;margin-top:4px">留空则由检测记录自动计算</div></el-form-item></el-col>
          <el-col :span="12"><el-form-item label="修缮状态"><el-select v-model="editForm.manualRepairStatus" clearable placeholder="自动计算" style="width:100%"><el-option label="待修缮" value="待修缮" /><el-option label="修缮中" value="修缮中" /><el-option label="已修缮" value="已修缮" /></el-select><div style="font-size:12px;color:#999;margin-top:4px">留空则由修缮申请自动计算</div></el-form-item></el-col>
          <el-col :span="24"><el-form-item label="详细地址"><el-input v-model="editForm.address" /></el-form-item></el-col>
          <el-col :span="24"><el-form-item label="描述"><el-input v-model="editForm.description" type="textarea" :rows="3" /></el-form-item></el-col>
          <el-col :span="24">
            <el-form-item label="现场图片">
              <div class="img-upload-list">
                <div v-for="(img, idx) in editForm.images" :key="idx" class="img-upload-item">
                  <el-image :src="resolveImageUrl(img)" fit="cover" class="img-thumb" :preview-src-list="resolveImageList(editForm.images)" />
                  <span class="img-delete" @click="removeEditImage(idx)">×</span>
                </div>
                <label class="img-upload-add" :class="{ disabled: uploading }">
                  <input type="file" accept="image/*" multiple style="display:none" @change="handleImageFileChange" :disabled="uploading" />
                  <span v-if="!uploading">＋ 上传图片</span>
                  <span v-else>上传中…</span>
                </label>
              </div>
              <div style="font-size:12px;color:#999;margin-top:4px">点击图片可预览，点击「×」删除，支持多选上传</div>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="周边环境">
              <el-checkbox-group v-model="editForm.envTagsArr" class="env-checkbox-group">
                <el-checkbox v-for="tag in ENV_TAG_OPTIONS" :key="tag" :label="tag">{{ tag }}</el-checkbox>
              </el-checkbox-group>
              <div style="font-size:12px;color:#999;margin-top:4px">泉井周边50米内存在的项目（可多选）</div>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="显示状态">
              <el-radio-group v-model="editForm.shelfStatus">
                <el-radio :label="1">显示</el-radio>
                <el-radio :label="2">隐藏</el-radio>
              </el-radio-group>
              <div style="font-size:12px;color:#999;margin-top:4px">隐藏后小程序端将不再展示该泉井</div>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <el-descriptions v-if="detail && (dialogMode === 'view' || dialogMode === 'audit')" :column="2" border>
        <el-descriptions-item label="名称">{{ detail.name }}</el-descriptions-item>
        <el-descriptions-item label="类型">{{ wellTypeText(detail.wellType) }}</el-descriptions-item>
        <el-descriptions-item label="水位标签"><el-tag>{{ detail.waterLevelLabel }}</el-tag></el-descriptions-item>
        <el-descriptions-item label="使用频率">{{ detail.useFrequencyText }}</el-descriptions-item>
        <el-descriptions-item label="省市区">{{ [detail.province, detail.city, detail.district].filter(Boolean).join(' / ') || '-' }}</el-descriptions-item>
        <el-descriptions-item label="详细地址">{{ detail.address || '-' }}</el-descriptions-item>
        <el-descriptions-item label="经度">{{ detail.longitude }}</el-descriptions-item>
        <el-descriptions-item label="纬度">{{ detail.latitude }}</el-descriptions-item>
        <el-descriptions-item label="上报人">{{ detail.reporterName || '-' }}</el-descriptions-item>
        <el-descriptions-item label="联系方式">{{ detail.contact || '-' }}</el-descriptions-item>
        <el-descriptions-item label="水质状态"><el-tag :type="statusType(detail.testStatusColor)">{{ detail.testStatus }}</el-tag></el-descriptions-item>
        <el-descriptions-item label="修缮状态"><el-tag :type="statusType(detail.repairStatusColor)">{{ detail.repairStatus }}</el-tag></el-descriptions-item>
        <el-descriptions-item label="守望者">{{ detail.guardianName || '未认领' }}</el-descriptions-item>
        <el-descriptions-item label="助力值">{{ detail.votes || 0 }}</el-descriptions-item>
        <el-descriptions-item label="泉井描述" :span="2">{{ detail.description || '-' }}</el-descriptions-item>
      </el-descriptions>
      <template v-if="dialogMode === 'view' || dialogMode === 'audit'">
      <div class="section-title">周边环境</div>
      <div><el-tag v-for="tag in envTags" :key="tag.name" class="env-tag" :type="tag.selected ? 'success' : 'info'">{{ tag.label }}</el-tag></div>
      <div class="section-title">现场图片</div>
      <div><el-image v-for="img in images" :key="img" class="photo" :src="resolveImageUrl(img)" :preview-src-list="resolveImageList(images)" /></div>
      </template>
      <el-form v-if="dialogMode === 'audit'" ref="auditForm" :model="auditForm" :rules="rules" label-width="90px" class="audit-form">
        <el-form-item label="审核结论" prop="reviewStatus">
          <el-radio-group v-model="auditForm.reviewStatus"><el-radio :label="2">已通过</el-radio><el-radio :label="3">未通过</el-radio></el-radio-group>
        </el-form-item>
        <el-form-item label="拒绝原因" prop="rejectReason" v-if="auditForm.reviewStatus === 3"><el-input v-model="auditForm.rejectReason" type="textarea" :rows="3" /></el-form-item>
      </el-form>
      <span slot="footer">
        <el-button @click="dialogVisible=false">关闭</el-button>
        <el-button v-if="dialogMode === 'audit'" type="primary" @click="submitAudit">提交审核</el-button>
        <el-button v-if="dialogMode === 'edit' || dialogMode === 'create'" type="primary" @click="submitEdit">保存</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { fetchWells, fetchWellDetail, reportWell, auditWell, updateWell, updateWellShelf, deleteWell, uploadImage } from '@/api'
import { resolveImageUrl, resolveImageList, unresolveImageList } from '@/utils/media'

export default {
  data() {
    return {
      ENV_TAG_OPTIONS: ['厕所', '农田', '养殖', '垃圾点', '排污沟', '公路', '民居', '隔离围墙'],
      loading: false,
      uploading: false,
      tableData: [],
      total: 0,
      dateRange: [],
      query: { pageNum: 1, pageSize: 10, name: '', reviewStatus: undefined, wellType: undefined, province: '', city: '', district: '', reporterKeyword: '' },
      dialogVisible: false,
      dialogMode: 'view',
      detail: null,
      editForm: {},
      auditForm: { id: null, reviewStatus: 2, rejectReason: '' },
      rules: { reviewStatus: [{ required: true, message: '请选择审核结论', trigger: 'change' }], rejectReason: [{ required: true, message: '请填写拒绝原因', trigger: 'blur' }] },
      editRules: { name: [{ required: true, message: '请输入泉井名称', trigger: 'blur' }], longitude: [{ required: true, message: '请输入经度', trigger: 'blur' }], latitude: [{ required: true, message: '请输入纬度', trigger: 'blur' }], wellType: [{ required: true, message: '请选择类型', trigger: 'change' }], waterLevel: [{ required: true, message: '请输入水位', trigger: 'blur' }], useFrequency: [{ required: true, message: '请输入使用频率', trigger: 'blur' }] }
    }
  },
  computed: {
    envTags() { return this.detail && this.detail.envTags ? this.detail.envTags : [] },
    images() { return this.detail && this.detail.images ? this.detail.images : [] },
    dialogTitle() { return this.dialogMode === 'audit' ? '泉井审核' : this.dialogMode === 'create' ? '新增泉井' : this.dialogMode === 'edit' ? '修改泉井' : '泉井详情' }
  },
  created() { this.loadData() },
  methods: {
    resolveImageUrl,
    resolveImageList,
    unresolveImageList,
    async loadData() {
      this.loading = true
      try {
        const params = { ...this.query }
        if (this.dateRange && this.dateRange.length === 2) {
          params.startTime = this.dateRange[0]
          params.endTime = this.dateRange[1]
        }
        Object.keys(params).forEach(key => {
          if (params[key] === '' || params[key] === null || params[key] === undefined) delete params[key]
        })
        const res = await fetchWells(params)
        this.tableData = res.records || []
        this.total = res.total || 0
      } finally { this.loading = false }
    },
    handleSearch() { this.query.pageNum = 1; this.loadData() },
    handleReset() {
      this.dateRange = []
      this.query = { pageNum: 1, pageSize: 10, name: '', reviewStatus: undefined, wellType: undefined, province: '', city: '', district: '', reporterKeyword: '' }
      this.loadData()
    },
    openCreate() {
      this.dialogMode = 'create'
      this.detail = null
      this.editForm = { name: '', longitude: '', latitude: '', address: '', province: '', city: '', district: '', wellType: 1, waterLevel: '', useFrequency: '', description: '', envTags: '', envTagsArr: [], images: [], reporterName: '', contact: '', shelfStatus: 1, manualTestStatus: '', manualRepairStatus: '' }
      this.dialogVisible = true
    },
    async openView(row) {
      this.dialogMode = 'view'
      this.detail = await fetchWellDetail(row.id)
      this.dialogVisible = true
    },
    async openEdit(row) {
      const detail = await fetchWellDetail(row.id)
      this.dialogMode = 'edit'
      const rawEnvTags = detail.envTags
      const envTagsArr = Array.isArray(rawEnvTags)
        ? rawEnvTags.filter(t => t.selected).map(t => t.name)
        : (typeof rawEnvTags === 'string' && rawEnvTags ? rawEnvTags.split(',').map(s => s.trim()).filter(Boolean) : [])
      const envTagsStr = envTagsArr.join(',')
      this.editForm = { ...detail, id: row.id, envTags: envTagsStr, envTagsArr, images: unresolveImageList(detail.images || []), waterLevel: Number(detail.waterLevel) || undefined, useFrequency: Number(detail.useFrequency) || undefined, shelfStatus: Number(detail.shelfStatus) || 1, manualTestStatus: detail.manualTestStatus || '', manualRepairStatus: detail.manualRepairStatus || '' }
      this.dialogVisible = true
    },
    async openAudit(row) {
      this.dialogMode = 'audit'
      this.auditForm = { id: row.id, reviewStatus: row.reviewStatus === 3 ? 3 : 2, rejectReason: row.rejectReason || '' }
      this.detail = await fetchWellDetail(row.id)
      this.dialogVisible = true
    },
    submitAudit() {
      this.$refs.auditForm.validate(async valid => {
        if (!valid) return
        await auditWell(this.auditForm)
        this.$message.success('审核已提交')
        this.dialogVisible = false
        this.loadData()
      })
    },
    submitEdit() {
      this.$refs.editForm.validate(async valid => {
        if (!valid) return
        if (this.dialogMode === 'create') {
          const payload = { ...this.editForm, envTags: (this.editForm.envTagsArr || []).join(',') }
          if (!payload.images || payload.images.length === 0) delete payload.images
          delete payload.shelfStatus
          const id = await reportWell(payload)
          if (Number(this.editForm.shelfStatus || 1) === 2) await updateWellShelf({ id, shelfStatus: 2, reason: '管理员隐藏' })
        } else {
          await updateWell({ ...this.editForm, envTags: (this.editForm.envTagsArr || []).join(','), waterLevel: Number(this.editForm.waterLevel), useFrequency: Number(this.editForm.useFrequency) })
          await updateWellShelf({ id: this.editForm.id, shelfStatus: this.editForm.shelfStatus || 1, reason: this.editForm.shelfStatus === 2 ? '管理员隐藏' : '' })
        }
        this.$message.success(this.dialogMode === 'create' ? '新增成功' : '修改成功')
        this.dialogVisible = false
        this.loadData()
      })
    },
    async toggleDisplay(row) {
      try {
        const nextStatus = Number(row.shelfStatus || 1) === 1 ? 2 : 1
        let reason = ''
        if (nextStatus === 2) {
          const result = await this.$prompt('请输入隐藏原因', '隐藏泉井', { confirmButtonText: '确认隐藏', cancelButtonText: '取消', inputValue: row.rejectReason || '管理员隐藏' })
          reason = result.value
        } else {
          await this.$confirm(`确认显示泉井「${row.name}」吗？`, '显示确认', { type: 'warning' })
        }
        await updateWellShelf({ id: row.id, shelfStatus: nextStatus, reason })
        this.$message.success(nextStatus === 1 ? '泉井已显示' : '泉井已隐藏')
        this.loadData()
      } catch (e) {}
    },
    exportList() {
      const headers = ['序号', '泉井名称', '类型', '水位', '使用频率', '省', '市', '区县', '详细地址', '经度', '纬度', '上报人', '联系方式', '上报时间', '审核状态', '显示状态']
      const rows = this.tableData.map((row, index) => [index + 1, row.name, row.wellTypeText || this.wellTypeText(row.wellType), row.waterLevelLabel, row.useFrequencyText, row.province, row.city, row.district, row.address, row.longitude, row.latitude, row.reporterName, row.contact, this.formatDateTime(row.createdAt), this.reviewText(row.reviewStatus), this.displayText(row.shelfStatus)])
      const csv = [headers, ...rows].map(items => items.map(item => `"${String(item == null ? '' : item).replace(/"/g, '""')}"`).join(',')).join('\n')
      const blob = new Blob(['\ufeff' + csv], { type: 'text/csv;charset=utf-8;' })
      const link = document.createElement('a')
      link.href = URL.createObjectURL(blob)
      link.download = `泉井列表_${new Date().toISOString().slice(0, 10)}.csv`
      link.click()
      URL.revokeObjectURL(link.href)
    },
    async handleDelete(row) {
      try {
        await this.$confirm(`确认删除泉井「${row.name}」吗？删除后列表将不再显示。`, '删除确认', { confirmButtonText: '确认删除', cancelButtonText: '取消', type: 'warning' })
        await deleteWell(row.id)
        this.$message.success('泉井已删除')
        this.loadData()
      } catch (e) {}
    },
    removeEditImage(idx) {
      this.editForm.images = this.editForm.images.filter((_, i) => i !== idx)
    },
    async handleImageFileChange(e) {
      const files = Array.from(e.target.files)
      if (!files.length) return
      this.uploading = true
      try {
        for (const f of files) {
          const url = await uploadImage(f)
          this.editForm.images = [...(this.editForm.images || []), url]
        }
      } catch (err) {
        this.$message.error('图片上传失败，请重试')
      } finally {
        this.uploading = false
        e.target.value = ''
      }
    },
    formatDateTime(value) { return value ? String(value).replace('T', ' ') : '-' },
    wellTypeText(v) { return v === 1 ? '泉' : v === 2 ? '井' : '未知' },
    reviewText(v) { return ['待审核', '审核中', '已通过', '未通过'][v] || '未知' },
    reviewType(v) { return v === 2 ? 'success' : v === 3 ? 'danger' : 'warning' },
    displayText(v) { return Number(v || 1) === 1 ? '显示' : '隐藏' },
    displayType(v) { return Number(v || 1) === 1 ? 'success' : 'info' },
    statusType(color) { return color === 'green' ? 'success' : color === 'red' ? 'danger' : 'warning' }
  }
}
</script>

<style scoped>
.filter-form ::v-deep .el-row { width: 100%; }
.filter-form ::v-deep .el-form-item { margin-bottom: 12px; }
.filter-form ::v-deep .el-form-item__content { width: calc(100% - 68px); }
.filter-form ::v-deep .el-input,
.filter-form ::v-deep .el-select,
.filter-form ::v-deep .el-date-editor { width: 100%; }
.filter-form ::v-deep .filter-actions .el-form-item__content { width: 100%; display: flex; gap: 8px; }
.filter-form ::v-deep .filter-actions .el-button { min-width: 72px; }
.action-bar { display: flex; align-items: center; flex-wrap: wrap; gap: 4px 10px; line-height: 20px; }
.action-text { cursor: pointer; font-size: 13px; user-select: none; }
.action-text:hover { text-decoration: underline; }
.action-text.view { color: #606266; }
.action-text.edit { color: #409eff; }
.action-text.audit { color: #2f8f5b; }
.action-text.delete { color: #f56c6c; }
.table-toolbar { display: flex; justify-content: flex-end; gap: 10px; margin-bottom: 12px; }
.display-btn { margin-left: 10px; }
.action-bar ::v-deep .el-button + .el-button { margin-left: 0; }
.cover { width: 56px; height: 56px; border-radius: 8px; background: #f2f2f2; }
.photo { width: 96px; height: 96px; border-radius: 10px; margin: 8px 8px 0 0; }
.section-title { margin: 18px 0 10px; font-weight: 700; color: #123c2f; }
.audit-form, .edit-form { margin-top: 18px; }
.edit-form ::v-deep .el-select { width: 100%; }
.img-upload-list { display: flex; flex-wrap: wrap; gap: 10px; }
.img-upload-item { position: relative; width: 90px; height: 90px; border-radius: 6px; overflow: hidden; border: 1px solid #e0e0e0; }
.img-thumb { width: 90px; height: 90px; }
.img-delete { position: absolute; top: 2px; right: 4px; color: #fff; background: rgba(0,0,0,.55); border-radius: 50%; width: 18px; height: 18px; line-height: 18px; text-align: center; font-size: 14px; cursor: pointer; }
.img-upload-add { display: flex; align-items: center; justify-content: center; width: 90px; height: 90px; border: 1px dashed #ccc; border-radius: 6px; cursor: pointer; font-size: 13px; color: #409eff; background: #fafafa; }
.img-upload-add.disabled { opacity: .5; cursor: not-allowed; }
.el-pagination { margin-top: 16px; text-align: right; }
.env-checkbox-group { display: flex; flex-wrap: wrap; gap: 4px 16px; padding-top: 4px; }
.env-checkbox-group ::v-deep .el-checkbox { margin-right: 0; }
</style>
